import React from 'react';
import './imageModal.css';
import closeBtn from '../../../public/images/btn_icon/ic_popup_close_black_24dp.svg';

const ImageModal = ({ isOpen, path, onClose }) => {
  // const absolutePath = 'https://perplayblobdev.blob.core.windows.net/perplay-hub';
  return (
    <div className="wrap" onClick={onClose}>
      <div
        className={'modal'}
        style={{ display: isOpen ? 'block' : 'none' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="btnContainer">
          {/*<p className="path">*/}
          {/*    {path.replace(absolutePath, '')}*/}
          {/*    /!*{path}*!/*/}
          {/*</p>*/}
            <div className="leftDiv">
                <p>미리보기</p>
            </div>
            <div className="rightDiv">
                <img className="close-btn" src={closeBtn} alt="" onClick={onClose} />
            </div>
        </div>
        <img className="modal-img" src={path} alt="" />
      </div>
    </div>
  );
};

export default ImageModal;
